// extracted by mini-css-extract-plugin
export default {"App":"App_App__Ftlb1","route-loading":"App_route-loading__VMKGa"};